/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import DoctorCards from "../../Component/DoctorCards";
import {
  GoogleMap,
  useJsApiLoader,
  MarkerF,
  Autocomplete,
} from "@react-google-maps/api";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BaseURL from "../../BaseURL/BaseURL";
import { useDispatch } from "react-redux";
import { doctorapi } from "../../Redux/Slice/Slice";
import Section from "../../Component/Section2/Section";
import './Home.css'
import FilterModal from "../../Component/FilterModal";
// import { FreeMode, Pagination } from 'swiper/modules';
// import 'swiper/css/free-mode';
// import 'swiper/css/pagination';
// import { Swiper, SwiperSlide } from 'swiper/react';

const containerStyle = {
  width: "100%",
  height: "500px",
};

const center = {
  lat: 24.8607343,
  lng: 67.0011364,
};

const Home = () => {
  
  const [, setLoader] = useState(false);
  const [api, setApi] = useState([]);
  const [, setSearchApi] = useState([]);
  const [Data, setData] = useState([]);
  const [name, setName] = useState("");
  const [Zip, setZip] = useState("");
  const [modalShow, setModalShow] = useState(false);

  const dispatch = useDispatch();

  const alldoctor = () => {
    setLoader(true);
    try {
      var config = {
        method: "Get",
        url: `${BaseURL.baseurl}/doctor`,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setApi(response.data.data);
          setData(response.data.data?.slice(0, 6));
          dispatch(doctorapi(response.data.data));
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  useEffect(() => {
    alldoctor();
  }, []);

  const [Position, setPosition] = useState({
    lat: 0,
    lng: 0,
  });
  const [PlaceName, setPlaceName] = useState("");
  //google map work

  const { isLoaded } = useJsApiLoader({
    // id: "google-map-script",
    googleMapsApiKey: "AIzaSyDF1PVJNBK1GGAQmfCpc-yepBkGUdkfgVQ",
    libraries: ["places"],
  });
  const autoCompleteRef = useRef();
  const inputRef = useRef();

  useEffect(() => {
    console.log("useeffect", +1);
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current
    );
    autoCompleteRef.current.addListener("place_changed", async function () {
      const Place = await autoCompleteRef.current.getPlace();
      // console.log(place.geometry.location.lat(),"place");
      // console.log(place.geometry.location.lng(),"place");
      setPosition({
        lat: Place.geometry.location.lat(),
        lng: Place.geometry.location.lng(),
      });
      // setPlaceName(place.formatted_address);
      setPlaceName(Place.name);
      console.log(Place, "place");
    });
  }, [Position]);


  //google map work

  const navigate = useNavigate();

  const search = () => {
    setLoader(true);
    try {
      var config = {
        method: "Get",
        url: `${BaseURL.baseurl}/doctor?zip_code=${Zip}&name=${name}`,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setSearchApi(response.data.data);
          navigate("/practitioner", { state: response.data.data });
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

useEffect(()=>{
  setModalShow(true);
},[])

  return (
    <>
      <Header />
      <div class="hero_map">
        <div className="" style={{}}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={
              Position.lat !== 0 && Position.lng !== 0 ? Position : center
            }
            zoom={3}
            options={{
              zoomControl: false,
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: false,
            }}
          >
            {api.map((e, index) => {
              return (
                <MarkerF
                  key={index}
                  position={{
                    lat: Number(e.lat),
                    lng: Number(e.lng),
                  }}
                />
              );
            })}
          </GoogleMap>
        </div>
        <form class="search_wp mt-2">
          <div id="custom-search-input">
            <div class="d-flex justify-content-between row">
              {/* <div className="col-12 col-md-3 px-0 mb-1">
                <Autocomplete>
                  <input
                    type="text"
                    ref={inputRef}
                    class="p-3 border-0 location w-100"
                    placeholder="Ex. Name, Specialization ...."
                  />
                </Autocomplete>
              </div> */}
              <div className="col-12 col-md-8 px-0 mb-1">
                <input
                  type="tel"
                  class="w-100 p-3 border-0 location"
                  placeholder="Enter Zip Code"
                  onChange={(e) => {
                    setZip(e.target.value);
                  }}
                />
              </div>

              <button
                type="button"
                class="btn-theme rounded-0 col-12 col-md-4"
                onClick={search}
              >
                Search
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="bg_color_1 mt-5">
        <div class="container margin_120_95">
           <span className="fs-2 fw-bolder p-1 col-lg-12" style={{borderRight:'4px solid #0d6efd'}}> What is Dentective?</span>
          <div class="main_title row">
          <div className="col-lg-6">
            <img src="./s4.png" className="pt-5" alt="ok"/>
            </div>
            <div className="col-lg-6">
            <p className="">
              The Global Alliance for Hypnosis Clinicians (Dentective) is the
              world’s most comprehensive database, training network, and
              certification program of medical doctors, dentists, and hypnosis
              practitioners specializing in medical hypnosis. The field of
              hypnosis is largely misunderstood and therefore underutilized in
              clinical settings. While hypnoanalgesia refers to the
              implementation of hypnosis in place of chemical anesthesia for
              invasive procedures, medical hypnosis can be utilized in a wide
              array of clinical situations such as helping patients overcome
              phobias, accelerating the recovery time from surgery, and
              providing significant pain relief. Dentective aims to overcome the
              long-held stigma regarding hypnosis and expand the application of
              this technique in medical settings all across the globe.
            </p>
            </div>
          </div>
          {/* <Section /> */}
          <div class="row">
            {Data?.map((e) => (
          <div className="col-lg-4">
              <DoctorCards
                id={e?.id}
                fname={e?.first_name}
                lname={e?.last_name}
                address={e?.address}
                city={e?.city}
                country={e?.country}
                bio={e?.bio}
                image={e?.profile_photo}
                rating={e?.avg_review}
                categories={e?.categories}
              />
            </div>
            ))}
          </div>
          {/* <!-- /row --> */}
          <p class="text-center add_top_30 mb-5">
            <Link to="/practitioner" class="btn btn-primary text-white">
              View all Dentist
            </Link>
          </p>
        </div>
        {/* <!-- /container --> */}
        {/* <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1>Intern Opportunities</h1>
              <p className="fs-5 py-3">
                If you have a passion for clinical hypnosis and the potential to
                help the public, please <Link to={"/contact"}>contact us</Link> to get involved.
              </p>
            </div>
          </div>
        </div> */}
      </div>
      {/* <!-- /hero_map --> */}
      <Footer />

      <FilterModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Home;
